// uppy
import { Dashboard } from '@uppy/react';
// hooks
import useUppy from '../../../hooks/useUppy';

// ----------------------------------------------------------------------

export default function FileUploader(props) {
  const { uppy } = useUppy();

  return (
    <Dashboard
      showNativePhotoCameraButton
      disableStatusBar
      uppy={uppy}
      proudlyDisplayPoweredByUppy={false}
      width={'100%'}
      height={'70vh'}
      {...props}
    />
  );
}
